import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { SingleDatePicker, DateRangePicker } from "react-dates";
import { Global } from "@emotion/core";
import "react-dates/lib/css/_datepicker.css";
import "react-dates/initialize";
import "moment/locale/pt-br";
import { styleConstants } from "nectar-ui";
import Single, { globalStyle } from "./style";

const { SM, MD } = styleConstants.sizes;
interface DatePickerProps {
  numberOfMonths?: number;
  displayFormat?: string;
  weekDayFormat?: string;
  validate?: string;
  allowPastDates?: boolean;
  period?: boolean;
  showInput?: boolean;
  size?: typeof SM | typeof MD;
}

const DatePicker = ({
  numberOfMonths = 1,
  displayFormat = "D/M/Y",
  weekDayFormat = "ddd",
  validate = "",
  allowPastDates = true,
  period = false,
  showInput = true,
  size = MD,
  ...props
}: DatePickerProps) =>
  period ? (
    // eslint-disable-next-line react/jsx-fragments
    <Fragment>
      {/* @ts-ignore */}
      <Global styles={globalStyle} />
      {/* @ts-ignore */}
      <DateRangePicker
        numberOfMonths={numberOfMonths}
        displayFormat={displayFormat}
        weekDayFormat={weekDayFormat}
        inputIconPosition="after"
        hideKeyboardShortcutsPanel
        showDefaultInputIcon
        noBorder
        {...props}
      />
    </Fragment>
  ) : (
    // @ts-ignore
    <Single isOpen={props.focused} showInput={showInput} validate={validate} size={size}>
      {/* @ts-ignore */}
      <Global styles={globalStyle} />
      {/* @ts-ignore */}
      <SingleDatePicker
        numberOfMonths={numberOfMonths}
        displayFormat={displayFormat}
        weekDayFormat={weekDayFormat}
        inputIconPosition="after"
        hideKeyboardShortcutsPanel
        showDefaultInputIcon
        isOutsideRange={() => !allowPastDates}
        noBorder
        {...props}
      />
    </Single>
  );

DatePicker.propTypes = {
  numberOfMonths: PropTypes.number,
  displayFormat: PropTypes.string,
  weekDayFormat: PropTypes.string,
  validate: PropTypes.string,
  allowPastDates: PropTypes.bool,
  period: PropTypes.bool,
  showInput: PropTypes.bool,
  size: PropTypes.oneOf([SM, MD])
};

DatePicker.defaultProps = {
  numberOfMonths: 1,
  displayFormat: "D/M/Y",
  weekDayFormat: "ddd",
  validate: "",
  allowPastDates: true,
  period: false,
  showInput: true,
  size: MD
};

export default DatePicker;
